module.exports = __webpack_public_path__ + "static/media/upArrow.5463c286.svg";